// libs
import _ from 'lodash'; //using debounce to help slow down searching
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import YTSearch from 'youtube-api-search';
// components
import SearchBar from './components/search_bar';
import VideoList from './components/video_list';
import VideoDetail from './components/video_detail';
// variables
const API_KEY = 'AIzaSyAeRx0zplVIk2tI_UO9Za1EeEUr8VDll1Y';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      videos: [],
      selectedVideo: null
    };

    this.videoSearch('');
  }

  videoSearch(term){
    // same as putting function(videos) { this.setState({videos: videos})}
    YTSearch({ key: API_KEY, term: term, maxResults: 25}, (videos) => {
      this.setState({ 
        videos: videos,
        selectedVideo: videos[0]
      });
    });
  }

  render() {
    const videoSearch = _.debounce((term) => { this.videoSearch(term) }, 300);

    return( 
      <div>
        <SearchBar onSearchTermChange={videoSearch} />
        <VideoDetail video={this.state.selectedVideo} />
        <VideoList 
          onVideoSelect={ selectedVideo => this.setState({selectedVideo}) }
          videos={ this.state.videos } />
      </div>
    )
  }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js